<template>
  <div class="col-lg-6 col-md-12 col-12 folovid__col mb-3">
    <div class="folovid__col-contenido pt-3 pb-2 mx-auto px-3 text-start">
      <p class="folovid__texto mb-0 ps-2">
        Porcentaje de vacunación en áreas de negocio:
      </p>
      <div class="folovid__col-vacunacion mx-auto">
        <div
          class="row folovid__row justify-content-center mt-3"
          v-if="areas_estadisticas"
        >
          <!-- Loop card de porcentaje de vacunación -->
          <div
            class="col-lg-11 col-md-11 col-11 card-porcentaje"
            v-for="(area, index) in areas_estadisticas"
            :key="index"
          >
            <div class="row card-porcentaje__row justify-content-center">
              <div
                class="col-lg-8 col-md-8 col-8 text-start card-porcentaje__col"
              >
                <p class="card-porcentaje__texto mb-0">
                  {{ area.nombre_area }}
                </p>
                <p class="card-porcentaje__texto-secundario mb-0">
                  {{ area.total_usuarios }} colaboradores
                </p>
              </div>
              <div
                class="col-lg-3 col-md-3 col-4 card-porcentaje__col text-end"
              >
                <span class="card-porcentaje__numero-porcentaje"
                  >{{ area.total_vacunados
                  }}<sup class="card-porcentaje__porcentaje" :style="{ color: colorPrimario }">%</sup></span
                >
              </div>
            </div>
          </div>
          <!-- Loop card de porcentaje de vacunación -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PorcentajeVacunacion",
  props: {
    areas_estadisticas: Array,
  },
};
</script>